import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { Cer } from '@reenstudio/app/core/models/cer/cer';
import { CerService } from '@reenstudio/app/core/services/api/cer.service';
import { MaterialModule } from '@reenstudio/app/material.module';
import { AbstractListComponent } from '@reenstudio/app/shared/components/abstract-list/abstract-list.component';
import { NoDataComponent } from '@reenstudio/app/shared/components/no-data/no-data.component';
import { AlertDialogService } from '@reenstudio/app/shared/services/alert-dialog/alert-dialog.service';
import { SnackbarService } from '@reenstudio/app/shared/services/snackbar/snackbar.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NGXLogger } from 'ngx-logger';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { first, map, merge, switchMap } from 'rxjs';

@Component({
  selector: 'app-cer-list',
  templateUrl: './cer-list.component.html',
  styleUrls: ['./cer-list.component.scss'],
  standalone: true,
  imports: [
    MaterialModule,
    TablerIconsModule,
    NgIf,
    NgxSkeletonLoaderModule,
    NoDataComponent,
    MaterialModule,
    MatSortModule,
    MatPaginatorModule,
    RouterModule,
  ],
})
export class CerListComponent extends AbstractListComponent {
  @Input() override displayedColumns = ['name', 'state', 'actions'];

  override dataTable: MatTableDataSource<Cer>;

  pageSize: number;
  pageIndex: number;
  pageTotal: number;

  constructor(
    private apiService: CerService,
    private logger: NGXLogger,
    private snackbarService: SnackbarService,
    private alertDialogService: AlertDialogService
  ) {
    super();
    this.dataTable = new MatTableDataSource<Cer>([]);
  }

  protected override getList() {
    merge(this.filterChanged, this.sort.sortChange)
      .pipe(
        switchMap(() => {
          this.loading.next(true);
          const params = {
            cerId: this.filters?.cerId,
            cerName: this.filters?.cerName,
            enabled: true,
            page: this.pageIndex + 1,
            pageSize: this.pageSize,
          };

          return this.apiService.getCers(params);
        }),
        map((res) => {
          this.dataLength = res.pagination.total;
          return res.data;
        })
      )
      .subscribe({
        next: (data) => {
          this.dataTable.data = data;
          this.loading.next(false);
        },
      });
  }

  applyFilter(event: Event) {
    if (event) {
    }
  }

  handlePageEvent(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.triggerFilterChange();
  }

  delete(cer: number) {
    this.alertDialogService.create(
      {
        title: 'Eliminazione CER con ID ' + cer,
        message: 'Sei sicuro/a di voler eliminare questa CER?',
        confirm: 'Si',
        cancel: 'No',
        type: 'warning',
      },
      () => {
        this.loading.next(true);
        this.apiService
          .deleteCer(<number>cer)
          .pipe(first())
          .subscribe({
            next: () => {
              this.snackbarService.success('CER eliminata con successo!');
            },
            error: (err) => {
              this.loading.next(false);
              let errorKeys = Object.keys(err.error.details.errors);
              let error;
              for (let key of errorKeys) {
                let currentArray = err.error.details.errors[key];
                error = currentArray[0];
              }
              this.snackbarService.error(error);
            },
            complete: () => this.triggerFilterChange(),
          });
      }
    );
  }
}
